import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { ClearIconWrapper, InputBoxOverlayRight } from './search-input.styled';
import SelectClearIcon from '@atlaskit/icon/core/migration/cross-circle--select-clear';
export var SearchInputOverlay = function SearchInputOverlay(_ref) {
  var theme = _ref.theme,
    showClearButton = _ref.showClearButton,
    onClear = _ref.onClear,
    allowChangeExpand = _ref.allowChangeExpand,
    clearSearchLabel = _ref.clearSearchLabel,
    toggleAISearchButton = _ref.toggleAISearchButton;
  return /*#__PURE__*/React.createElement(InputBoxOverlayRight, null, showClearButton && /*#__PURE__*/React.createElement(ClearIconWrapper, _extends({}, theme, {
    role: "button",
    onClick: onClear,
    onMouseEnter: function onMouseEnter() {
      allowChangeExpand === null || allowChangeExpand === void 0 || allowChangeExpand(false);
    },
    onMouseLeave: function onMouseLeave() {
      allowChangeExpand === null || allowChangeExpand === void 0 || allowChangeExpand(true);
    },
    tabIndex: 0
  }), /*#__PURE__*/React.createElement(SelectClearIcon, {
    color: "currentColor",
    label: clearSearchLabel || 'Clear search session',
    LEGACY_size: "small"
  })), toggleAISearchButton);
};